var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zone",on:{"click":_vm.hangleGoZone}})
}
var staticRenderFns = []

export { render, staticRenderFns }